import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import {
  calculateReadingTime,
  formatPostDate,
  postExcerpt,
  postSlug,
  postTitle,
} from '../utils/postHelpers';

/**
 * One entry in an index of writing. A rule, a date, a serif title — no card,
 * no thumbnail. The whole row is the link.
 */
function PostRow({ post, excerptLength = 165 }) {
  const title = postTitle(post);
  const readingTime = calculateReadingTime(post.content);

  return (
    <article className="border-b border-rule">
      <Link
        to={`/posts/${postSlug(post)}`}
        className="group grid gap-2 py-7 grid-cols-1 sm:grid-cols-[8.5rem_minmax(0,1fr)] sm:gap-8 transition-colors"
      >
        <div className="label pt-1.5 sm:pt-2.5 group-hover:text-signal transition-colors">
          {formatPostDate(post.date, { year: 'numeric', month: 'short', day: 'numeric' })}
        </div>

        <div className="space-y-2">
          <h3 className="text-headline flex items-start gap-2 group-hover:text-signal transition-colors">
            <span>{title}</span>
            <ArrowUpRight
              className="mt-1.5 h-4 w-4 shrink-0 opacity-0 -translate-x-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0"
              aria-hidden="true"
            />
          </h3>
          <p className="max-w-prose [overflow-wrap:anywhere] text-[0.9375rem] leading-relaxed text-muted-foreground">
            {postExcerpt(post, excerptLength)}
          </p>
          <p className="label pt-1">{readingTime} min read</p>
        </div>
      </Link>
    </article>
  );
}

export default PostRow;
